import { BasicSearchData } from './BasicSearchData.js';

export class MainSearchData extends BasicSearchData {
    constructor() {
        super();
        /**
         * @property {number} siCd - 시 코드(단일)
         */
        this.siCd= 0;
        /**
         * @property {number} guCd - 구 코드(단일)
         */
        this.guCd= 0;
        /**
         * @property {number} dnCd - 동 코드(단일)
         */
        this.dnCd= 0;
        /**
         * @property {array} chkCtgrsCd - 카테고리 코드(물건종류 복수)
         */
        this.chkCtgrsCd= [];
        /**
         * @property {number} chkAllCtgr - 전체선택
         */
        this.chkAllCtgr= 0;
        /**
         * @property {number} sn1 - sn1
         */
        this.sn1= 0;
        /**
         * @property {number} sn2 - sn2
         */
        this.sn2= 0;
    }
}